/**
 * Get new object with filtered pipelines
 * @param {object} pipelines unfiltered
 * @param {function} func filter
 * @return {object} pipelines filtered
 */

const filterPipelines = (pipelines, func) =>
  Object.entries(pipelines).reduce(
    (acc, [key, array]) => {
      acc[key] = array.filter(func)
      return acc
    },
    {
      interested: [],
      booked: [],
      refused: [],
      preAccess: [],
      finalReview: [],
      approved: [],
    },
  )

export { filterPipelines }



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/utils.js